import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Html5Qrcode } from 'html5-qrcode';

const BarcodeModal = ({ show, onClose, onScanSuccess }) => {
  const html5QrCodeRef = useRef(null);
  const [isScanning, setIsScanning] = useState(false);

  useEffect(() => {
    if (show) {
      const html5QrCode = new Html5Qrcode("reader");
      html5QrCodeRef.current = html5QrCode;

      Html5Qrcode.getCameras()
        .then(devices => {
          if (devices && devices.length > 0) {
            html5QrCode.start(
              { facingMode: "environment" },
              { fps: 10, qrbox: { width: 250, height: 150 } },
              (decodedText) => {
                onScanSuccess(decodedText);
                stopScanner();
              },
              () => {}
            ).then(() => setIsScanning(true))
             .catch(err => console.error("Erro ao iniciar scanner:", err));
          }
        })
        .catch(err => console.error("Erro ao obter câmeras:", err));
    }

    return () => {
      stopScanner();
    };
  }, [show]);

  const stopScanner = async () => {
    const scanner = html5QrCodeRef.current;
    if (!scanner) return;

    try {
      if (isScanning) {
        await scanner.stop();
        await scanner.clear();
        setIsScanning(false);
        const el = document.getElementById("reader");
        if (el) el.innerHTML = "";
      }
    } catch (err) {
      console.warn("Erro ao parar scanner:", err);
    }
  };

  const handleClose = () => {
    stopScanner().finally(() => onClose());
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Escanear Código</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div id="reader" style={{ width: "100%" }}></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BarcodeModal;
